import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-back-navigation-button',
	templateUrl: './back-navigation-button.component.html',
	styleUrls: ['./back-navigation-button.component.scss'],
})
export class BackNavigationButtonComponent implements OnInit {
	@Input() buttonName;
	@Output() goBack = new EventEmitter();
	@Input() showDefaultIcon = true;
	@Input() textColor = 'text-[#1a0c2f]';

	constructor() {}

	ngOnInit(): void {}
}
